module.exports = __webpack_public_path__ + "static/media/uma-logo-badge.064e4ceb.png";